module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Code/Minus-4817dde1507547357ff843100cc42d4c1c0ca47c9ced64645c9bbefc0fe7a83f.svg";